// OSRS-accurate gamemode labels + colors (true HC = red, Ironman = silvery grey).
export const MODE_LABEL = {
  main: "Main",
  ironman: "Ironman",
  hardcore: "HC Ironman",
  ultimate: "Ultimate IM",
  group: "Group IM",
  hardcore_group: "HC Group IM",
};

export const MODE_COLOR = {
  main: "#4CD964",           // main green
  ironman: "#9AA0A6",        // ironman grey
  hardcore: "#E23B3B",       // hardcore red
  ultimate: "#D8DBE0",       // ultimate silver
  group: "#3B9EFF",          // group ironman blue
  hardcore_group: "#B22222", // hardcore group crimson
};

export function modeColor(gamemode) {
  return MODE_COLOR[gamemode] || MODE_COLOR.main;
}
